import React, { PureComponent } from 'react';
import { Checkbox, InputNumber } from 'antd';
import { func, object } from 'prop-types';
import intl from 'react-intl-universal';
import Schema from 'async-validator';
import './AutoFlipConfigs.scss';

const defaultValue = { shouldAutoFlip: false, seconds: '5' };

const descriptor = {
  seconds: {
    type: 'string',
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        if (!/^[1-9]\d*$/.test(value)) {
          reject(intl.get('Preferences.Content.FullScreen.SecondsInvalid'));
        }
        if (parseInt(value, 10) > 99999) {
          reject(intl.get('Preferences.Content.FullScreen.SecondsTooLong'));
        }
        resolve();
      });
    },
  },
};
const validator = new Schema(descriptor);

class AutoFlipConfigs extends PureComponent {
  static propTypes = {
    value: object,
    onChange: func,
  }

  constructor(props) {
    super(props);
    this.state = { tempNumber: props.value.seconds };
    this.triggerChange = this.triggerChange.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSecondChange = this.handleSecondChange.bind(this);
  }

  triggerChange(changedValue) {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  handleChecked(e) {
    e.preventDefault();
    this.triggerChange({ shouldAutoFlip: e.target.checked })
  }

  handleSecondChange(text) {
    const { tempNumber } = this.state;
    const seconds = typeof text === 'number' ? text : tempNumber;
    this.triggerChange({ seconds });
    this.setState({ tempNumber: seconds })
  }

  render() {
    const { value: { shouldAutoFlip, seconds } } = this.props;

    return <>
      <Checkbox checked={shouldAutoFlip} onChange={this.handleChecked}>
        {intl.get('Preferences.Content.FullScreen.AutoFlipPrefix')}
      </Checkbox>
      <InputNumber
        min={1}
        max={99999}
        step={1}
        precision={0}
        className="seconds"
        disabled={!shouldAutoFlip}
        value={seconds}
        onChange={this.handleSecondChange}
      />
      {intl.get('Preferences.Content.FullScreen.AutoFlipSuffix')}
    </>
  }
}

export default AutoFlipConfigs;
export { validator, defaultValue };
